import React from 'react'
import Navbar from '../../../components/navbar/Navbar'
import styled from './Teachers.module.css'
import { Link } from 'react-router-dom'
import maleAvatar from "../../../assets/maleAvatar.webp"
import { db } from '../../../firebase/firebase'
import { getDocs, collection } from 'firebase/firestore';
import { useEffect, useState } from 'react' 
import { useTranslation } from 'react-i18next'
import { isApprovedTeacher } from '../../../utils/teacherStatus'
const Teachers = () => {
   const [teacherList, setTeacherList] = useState([]) 
   const { t } = useTranslation()
   const teacherCollectionRef = collection(db, "teachers");
   
   const getTeacherList = async () => {
       const data = await getDocs(teacherCollectionRef)
       const filteredData = data.docs
         .map((doc) => ({...doc.data(), id: doc.id}))
         .filter(isApprovedTeacher)
       setTeacherList(filteredData)
     }
        useEffect(() => {
          getTeacherList()
        }, []);
  return (
  <>
  <Navbar />
  <div className={styled.container}>
   {teacherList.map((teacher) => {
    const {userId, firstName, lastName, gender, birthYear, profileImage} = teacher
 
    return (
        <div className={styled.card} key={userId}>
        <img className={styled.img} src={profileImage || maleAvatar} alt="" />
        <div className={styled.name}>
          <h2> {t('Teachers.teacher:')} {firstName} {lastName}</h2>
        </div>
        <div className={styled.genAge}>
          <h3>
            {birthYear != null && birthYear !== "" && !Number.isNaN(Number(birthYear))
              ? new Date().getFullYear() - Number(birthYear)
              : null}
          </h3>
          <h3>{gender}</h3>
        </div>
       
         <Link to={`/teachers/${userId}`} className={styled.btn}>
                {t('Teachers.details')}
        </Link>
       
      </div>
    )
   })}
  </div>
  </>
  )
}

export default Teachers
